export default function DismissalStateControl({ active = false, onToggle, interactive = false }) {
  const className = `sd-dismissal-toggle ${active ? 'live' : 'inactive'}`;
  const dot = <span className={`sd-dismissal-toggle-dot ${active ? 'live' : 'inactive'}`} aria-hidden="true"></span>;
  const label = <span className="sd-dismissal-toggle-label">{active ? 'LIVE' : 'INACTIVE'}</span>;

  if (interactive) {
    return (
      <button
        type="button"
        className={className}
        onClick={onToggle}
        aria-pressed={active}
        title={`Switch dismissal to ${active ? 'inactive' : 'live'}`}
      >
        {dot}
        {label}
      </button>
    );
  }

  return (
    <span
      className={`${className} sd-dismissal-toggle-static`}
      role="status"
      aria-live="polite"
    >
      {dot}
      {label}
    </span>
  );
}
